import React from 'react';
import getEventUrlProps from './../helpers/getEventUrl';
import { Loader } from "kui";
import { EHintKey, HintHOC } from "app/view/react_components/hints";
import { GO_TO_GOOGLE_CALENDAR_HINT_TEXT } from "app/view/react_components/aside_panel/cardDetails/TimingSection/pushToGoogleCalendar/components/constants";

const GooglePushToElements = (props) => {
    const AddedCalendarIcon = require('!!@svgr/webpack!../../../../../../../../../../assets/svg/go-to-google-calendar-24.svg').default;
    return (
        <ul className="move-card__boards">
            {
                props.elements.map((el, i) => {
                    const isDisabled = props.disabledElements.indexOf(el.id) > -1;
                    const itemClass = `move-card__list ${isDisabled ? 'move-card__list--disabled' : ''}`;
                    const hrefProps = getEventUrlProps(el.id);

                    return (
                        <li className={itemClass} key={i} onClick={event => props.onClick(event, el)}>
                            <span className="move-card__list-name">{el[props.elementName]}</span>
                            {   props.loadingElement == el.id &&
                                <Loader className={'move-card__list-loader'} />
                            }
                            {
                                props.selectedElements.indexOf(el.id) > -1 &&
                                <a className="js-gc-link" {...hrefProps}>
                                    <span className="icon move-card__list-ico">
                                        <AddedCalendarIcon />
                                    </span>
                                </a>
                            }
                            <HintHOC
                                key={EHintKey.GO_TO_GOOGLE_CALENDAR_HINT}
                                hintKey={EHintKey.GO_TO_GOOGLE_CALENDAR_HINT}
                                show
                                direction={'left'}
                                arrow={'right'}
                                value={GO_TO_GOOGLE_CALENDAR_HINT_TEXT}
                                selector={`.move-card__list-ico`}
                            />
                        </li>
                    );
                })
            }
            {
                props.elements.length === 0 && (
                    <li className="move-card__list">¯\_(ツ)_/¯</li>
                )
            }
        </ul>
    );
};

GooglePushToElements.defaultProps = {
    elementName: 'name',
    loadingElement: null,
    selectedElements: [],
    disabledElements: [],
    elements: [],
    onClick: () => {}
};

export default GooglePushToElements;
